import { render, staticRenderFns } from "./EnidUserName.vue?vue&type=template&id=042020a8&scoped=true&"
import script from "./EnidUserName.vue?vue&type=script&lang=js&"
export * from "./EnidUserName.vue?vue&type=script&lang=js&"
import style0 from "./EnidUserName.vue?vue&type=style&index=0&id=042020a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042020a8",
  null
  
)

export default component.exports